var map = null;
var markers = null;
var infowindows = new Array();
var mapMarkers = new Array();
var mapOptions;
var markerCluster;

jQuery(function(){
    if (jQuery('#maps-map-container').length > 0)
    {
        mapOptions = {
            center: new google.maps.LatLng(37.7515702,-102.2120532),
            zoom: 4,
            maxZoom : 0,
            minZoom : 0,
            scrollwheel: false,
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#444444"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#ffb100"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#808080"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#ff0000"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        },
                        {
                            "color": "#ff9a00"
                        },
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#97d3fc"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ]
        };


        var url = jQuery('#maps-map-container').attr('data-url');
        jQuery('#maps-map-container').css('display','inline');
        jQuery.get(url + 'pins/', '', function(data){
            markers = data['markers'];
            initialize(mapOptions);
        }, 'JSON');

        jQuery('#bekijk-in-maps').click(function(){
            infowindows = new Array();

            jQuery.get('contact/getmarkers/', '', function(data){
                while(mapMarkers.length){
                    mapMarkers.pop().setMap(null);
                }

                markers = data['markers'];

                var mapOptions = {
                    center: new google.maps.LatLng(markers[0].lat, markers[0].long),
                    zoom: 10,
                    maxZoom : 100,
                    minZoom : 3,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };

                initialize(mapOptions);
            }, 'JSON')

            return false;
        })
    }
})

function showTab(id)
{
    jQuery('.tab').hide();
    jQuery('#'+id).show();
    jQuery('.tab-name').removeClass('tab-name-active');
    jQuery('#tab-name-'+id).addClass('tab-name-active');
}

function getDirections()
{
    if(directionsRenderer !== null && directionsRenderer !== undefined){
        directionsRenderer.setMap(null);
        marker1.setMap(null);
        marker2.setMap(null);
    }

    directionsRenderer = new google.maps.DirectionsRenderer({
        draggable: true,
        suppressInfoWindows: true,
        suppressMarkers: true
    });
    directionsRenderer.setMap(map);

    var directionsService = new google.maps.DirectionsService();

    var bestemming = (jQuery('#destination').val());
    bestemming = bestemming.replace(/(^\s*)|(\s*$)/g, "");
    if(bestemming.match(/^[1-9][0-9]{3}[\s][A-Z]{2}$/i))
    {
        bestemming += ", Nederland";
    }

    directionsService.route({
        origin: address,
        destination: bestemming,

        travelMode: google.maps.DirectionsTravelMode.DRIVING,
        unitSystem: google.maps.DirectionsUnitSystem.METRIC
    }, function(response, status) {
        if (status == google.maps.DirectionsStatus.OK)
        {
            directionsRenderer.setDirections(response);
            var leg = response.routes[ 0 ].legs[ 0 ];
            marker1 = new google.maps.Marker({
                position: leg.start_location,
                map: map
            });
            google.maps.event.addListener(marker1, 'click', function() {
                getInfoWindowEvent(marker1, createInfoWindowContent());
            });

            marker2 = new google.maps.Marker({
                position: leg.end_location,
                map: map
            });

            google.maps.event.addListener(marker2, 'click', function() {
                getInfoWindowEvent(marker2, leg.end_address);
            });

        } else if(status == google.maps.DirectionsStatus.ZERO_RESULTS){
            alert('De opgegeven postcode kon niet worden gevonden, probeert u het nog eens.');
        } else {
            alert('Error: ' + status);
        }
    });
}

function openMapInfowindow(id){
    for (var i=0; i<infowindows.length; i++)
    {
        infowindows[i].close(map, mapMarkers[i]);
    }
    infowindows[id].open(map, mapMarkers[id]);
}

function openPostcodeWoonplaats(locatie)
{
    $.ajax({
        url: window.location.href,
        data: { locatie:locatie, action: 'getCoordsByLocation'},
        type: 'post',
        dataType: 'json',
        success: function(data)
        {
            var newLocation = new google.maps.LatLng(data[0].lat, data[0].lng)
            map.setCenter(newLocation);
            map.setZoom(11);
        }
    });
}

function initialize(mapOptions)
{
    map = new google.maps.Map(document.getElementById("maps-map-container"), mapOptions);

    google.maps.Map.prototype.clearMarkers = function() {
        if(mapMarkers != undefined) {
            for (var i = 0; i < mapMarkers.length; i++) {
                mapMarkers[i].setMap(null);
            }
            mapMarkers = new Array();
        }
    };

    var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    mapMarkers = markers.map(function(location, i) {
        var marker = new google.maps.Marker({
            position: { lat: parseFloat(location.lat), lng: parseFloat(location.long) },
            title: location.naam,
            icon: location.image
        });

        infowindows[i] = new google.maps.InfoWindow({
            content:location.content
        })

        google.maps.event.addListener(marker, 'click', function(){
            openMapInfowindow(i);
            // infowindows[mapMarkers.indexOf(this)].open(map, this);
        })

        return marker;
    });

    markerCluster = new MarkerClusterer(map, mapMarkers, {
        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
    });
}